import React from 'react';

const Company = () => {
    return (
        <svg width='60' height='60' viewBox='0 0 60 60'>
            <defs>
                <linearGradient id='gegltc9vpa' x1='0%' x2='100%' y1='50%' y2='50%'>
                    <stop offset='0%' stopColor='#6d62ef' />
                    <stop offset='100%' stopColor='#9853F6' />
                </linearGradient>
            </defs>
            <g fill='none' fillRule='evenodd'>
                <g fill='url(#gegltc9vpa)' transform='translate(-880.000000, -415.000000)'>
                    <g>
                        <path
                            d='M146.247 90.477c-1.019 0-1.853-.834-1.853-1.853v-3.268h10.619v3.268c0 1.02-.834 1.853-1.853 1.853h-6.913zm12.472-5.127v3.274c0 3.064-2.495 5.56-5.56 5.56h-6.912c-3.064 0-5.56-2.496-5.56-5.56V85.35h-16.98c-.482 0-.958-.043-1.421-.136v16.08c0 2.044 1.661 3.706 3.706 3.706h47.43c2.044 0 3.706-1.662 3.706-3.706v-16.08c-.464.087-.94.136-1.421.136h-16.988zm20.694-24.888v17.475c0 1.545-.945 2.867-2.285 3.422-.439.18-.92.285-1.421.285H123.706c-.506 0-.982-.1-1.42-.285-1.34-.555-2.286-1.877-2.286-3.422V60.462c0-2.045 1.662-3.707 3.706-3.707h11.028c.204-.63 5.024-11.755 14.917-11.755s14.824 11.12 15.028 11.75h11.028c2.044.005 3.706 1.66 3.706 3.712zm-20.706-3.707c-.219-.66-.501-1.294-.844-1.904-.336-.596-.726-1.16-1.173-1.688-.06-.07-.12-.146-.185-.215-1.825-2.05-4.227-3.18-6.798-3.193-2.571.007-4.974 1.136-6.8 3.193-.06.07-.123.14-.184.215-.447.527-.837 1.098-1.173 1.688-.343.61-.625 1.244-.843 1.904h18z'
                            transform='translate(760.000000, 370.000000)'
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Company;
